/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import InfiniteLoader from 'react-virtualized/dist/commonjs/InfiniteLoader';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import List from 'react-virtualized/dist/commonjs/List';
import { Empty, Spin } from 'antd';

import { Select } from '@atoms';
import { usePagesInfiniteList } from '@api/hooks';

import s from './styles.module.less';

const PAGE_SORTING_OPTION = {
  RECENT: {
    value: '-modified',
    label: 'Most recent page',
  },
  RELATED: {
    value: 'related',
    label: 'Child pages',
  },
  ALL: {
    value: '',
    label: 'All pages',
  },
};
const DEFAULT_PAGE_SORTING_OPTIONS = [PAGE_SORTING_OPTION.RECENT, PAGE_SORTING_OPTION.ALL];
const EVENT_PAGE_SORTING_OPTIONS = [PAGE_SORTING_OPTION.RELATED];

const PER_PAGE = 15;

const PageComboSelect = ({ onAdd, isAdded, eventId, siteId, ...props }) => {
  const sortingOptions = eventId ? EVENT_PAGE_SORTING_OPTIONS : DEFAULT_PAGE_SORTING_OPTIONS;
  const defaultSort = sortingOptions[0];

  const [sortOption, setSortOption] = React.useState(defaultSort.value);
  const { pages, total, isFetching, fetchMore, canFetchMore } = usePagesInfiniteList({
    sort: sortOption,
    perPage: PER_PAGE,
    ...(eventId && { eventId }),
    ...(siteId && { siteId }),
  });

  const isRowLoaded = ({ index }) => !canFetchMore || index < pages.length;

  const renderRow = ({ index, style, key }) => {
    const currentPage = pages[index];
    const added = isAdded(currentPage);

    return (
      <div key={key} style={style} className={clsx(s.pageItem, { [s.added]: added })}>
        {isRowLoaded({ index }) ? (
          <>
            <span className={s.pageItemTitle} title={currentPage.title}>
              {currentPage.title}
            </span>
            <button type="button" disabled={added} className={s.pageItemButton} onClick={() => onAdd(currentPage)}>
              +
            </button>
          </>
        ) : (
          <Spin style={{ margin: '0 auto' }} spinning />
        )}
      </div>
    );
  };

  const renderNoRows = () =>
    isFetching ? (
      <div style={{ textAlign: 'center' }}>
        <Spin spinning />
      </div>
    ) : (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    );

  const rowCount = pages.length === total ? total : pages.length + 1;
  const loadMoreRows = isFetching ? () => {} : () => fetchMore();

  return (
    <div className={s.root} {...props}>
      <Select className={s.sortingField} value={sortOption} onChange={setSortOption} options={sortingOptions} />

      <InfiniteLoader isRowLoaded={isRowLoaded} loadMoreRows={loadMoreRows} rowCount={rowCount} threshold={5}>
        {({ onRowsRendered, registerChild }) => (
          <AutoSizer disableHeight>
            {({ width }) => (
              <List
                ref={registerChild}
                className={s.pagesList}
                height={300}
                overscanRowCount={3}
                noRowsRenderer={renderNoRows}
                rowCount={rowCount}
                rowHeight={35}
                rowRenderer={renderRow}
                onRowsRendered={onRowsRendered}
                width={width}
              />
            )}
          </AutoSizer>
        )}
      </InfiniteLoader>
    </div>
  );
};

export default PageComboSelect;
